import { Button } from "@mui/material";
import CommponentOptions from "./commponentOptions";

export const fullSelectedCemeteries = (cemeteries) => {
 return cemeteries
 ?.map((cemetery) => {
   return CommponentOptions({
     value: cemetery?.unicId || '',
     label: cemetery?.cemeteryNameHe || ''
   });
 })
}
export const fullSelectedBlocks = (blocks) => {
 return blocks
 ?.map((block) => {
   return CommponentOptions({
     value: block?.unicId,
     label: block?.blockNameHe,
     dataUnderRigth: {
       title: 'בית עלמין: ',
       value: block?.cemeteryNameHe
     }
   });
 })
}
export const fullSelectedPlots = (plots) => {
 return plots?.map((plot) => {
   return CommponentOptions({
     value: plot?.unicId,
     label: plot?.plotNameHe,
     dataUnderRigth: { title: 'גושים: ', value: plot?.blockNameHe },
     dataUnderLeft: { title: 'בית עלמין: ', value: plot?.cemeteryNameHe }
   });
 })
}
export const fullSelectedRows = (rows, btnAdd = false, setOpen = () => {}) => {
 if (btnAdd) {
   return [...rows?.map((row) => {
     return CommponentOptions({
       value: row?.unicId,
       label: row?.lineNameHe,
       dataUnderRigth: { title: 'חלקה: ', value: row?.plotNameHe },
       dataUnderLeft: { title: 'גוש: ', value: row?.blockNameHe }
     });
   }),
   {
     value: 'add',
     label: '',
     list: <Button onClick={() => setOpen(true)}>הוספת שורה</Button>,
     searchFields: ''
   }]
 } else {
   return rows?.map((row) => {
     return CommponentOptions({
       value: row?.unicId,
       label: row?.lineNameHe,
       dataUnderRigth: { title: 'חלקה: ', value: row?.plotNameHe },
       dataUnderLeft: { title: 'גוש: ', value: row?.blockNameHe }
     });
   })
 }
}
export const fullSelectedAreaGraves = (areaGraves) => {
 return areaGraves?.map((areaGrave) => {
   return CommponentOptions({
     value: areaGrave?.unicId,
     label: areaGrave?.areaGraveNameHe,
     dataUnderRigth: { title: 'שורה: ', value: areaGrave?.lineNameHe },
     dataUnderLeft: { title: 'חלקה: ', value: areaGrave?.plotNameHe }
   });
 })
}
export const fullSelectedGraves = (graves) => {
 return graves?.map((grave) => {
   return CommponentOptions({
     value: grave?.unicId,
     label: grave?.graveNameHe,
     dataUnderRigth: { title: 'שורה: ', value: grave?.lineNameHe },
     dataUnderLeft: { title: 'חלקה: ', value: grave?.plotNameHe }
   });
 })
}
export const fullSelectedCustomers = (customers) => {
 return customers?.map((cust) => {
  return CommponentOptions({
   value: cust?.unicId,
   label: `${cust?.firstName} ${cust?.lastName}`,
   dataUnderRigth: { title: 'זיהוי: ', value: cust?.numId }
 });
 })
}
export const fullSelectedContacts = (customers) => {
 return customers?.map((cust) => {
  return CommponentOptions({
   value: cust?.unicId,
   label: `${cust?.firstName} ${cust?.lastName}`,
   dataUnderRigth: { title: 'זיהוי: ', value: cust?.numId }
 });
 })
}
export const fullSelectedCountries = (countries) => {
 return countries?.map((item) => {
  return CommponentOptions({
    value: item?.unicId,
    label: item?.countryNameHe
  });
 })
}
export const fullSelectedCities = (cities) => {
 return cities?.map((item) => {
  return CommponentOptions({
    value: item?.unicId,
    label: item?.cityNameHe,
    dataUnderRigth: {
      title: 'מדינה: ',
      value: item?.countryNameHe
    }
  });
 })
}